import React from 'react';
import PropTypes from 'prop-types';
import icons from '../../../helpers/Icons';

const AvatarUpload = ({
  name,
  avatarSrc,
  onFileSelect,
  onFileRemove,
  acceptedTypes,
}) => {
  return (
    <div className="avatar__preview">
      <img alt="user avatar" src={avatarSrc} />
      <input
        id="file-upload-input"
        name={name}
        type="file"
        accept={acceptedTypes.join(', ')}
        className="upload-input"
        onChange={onFileSelect}
      />
      <div className="avatar__preview__options">
        <label htmlFor="file-upload-input" className="file-icon">
          {icons('upload')}
        </label>
        <span className="file-icon" onClick={onFileRemove}>
          {icons('delete')}
        </span>
      </div>
      <style jsx="true">{`
        .upload-input {
          z-index: -1;
          width: 0.1px;
          height: 0.1px;
          position: absolute;
        }
        .file-icon {
          cursor: pointer;
          width: auto;
        }
        .avatar__preview {
          position: relative;
          max-width: 170px;
          height: 180px;
          border: 1px solid #eae8eb;
          border-radius: 5px;
          background-color: #808080;
          margin-top: 22px;
        }
        .avatar__preview:hover > .avatar__preview__options {
          opacity: .6; 
        }
        .avatar__preview img {
          height: 100%;
          width: 100%;
        }
        .avatar__preview__options {
          display: flex;
          justify-content: space-evenly;
          transition: all .3s;
          position: absolute;
          width: 100%;
          height: 30px;
          background-color: #000;
          opacity: 0;
          bottom: 0;
          padding-top: 2px;
        }
      `}</style>
    </div>
  );
};

AvatarUpload.propTypes = {
  name: PropTypes.string.isRequired,
  avatarSrc: PropTypes.string.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
};

AvatarUpload.defaultProps = {
  acceptedTypes: [],
};

export default AvatarUpload;
